export default "__VITE_ASSET__DLJ2HhJg__"